var render, staticRenderFns
import script from "./ComunicationSection.vue?vue&type=script&lang=js"
export * from "./ComunicationSection.vue?vue&type=script&lang=js"
import style0 from "./ComunicationSection.vue?vue&type=style&index=0&id=8f88fb82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f88fb82",
  null
  
)

export default component.exports